module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_html.js
// module id = 847
// module chunks = 3